/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import throttle from 'lodash/throttle';
//---

import survey from '../../context/survey';
import action from '../../../../embedded-type/broadcast/actions/nps';

// set top
/**
 * survey widget 表示コントロール component
 * - `triggerIdName` HTMLElement チェックし表示コントロールします
 * - 開始処理: 表示時には config.step: 0 -> dispatch します
 * - HTMLElement 存在する時は scroll 監視を開始しヒットテストを行いヒット後開始処理します
 * @param {*} state React.Context config.state
 * @param {function} dispatch React.Context config.dispatch
 * @param {boolean} embedded embedded type flag
 * @param {boolean} desktop resize: desktop size flag
 * @param {*} [nps={}] Redux.store - nps, embedded type nps から送信されます
 * @param {*} props React.prop - children
 * @return {*} React.node - 表示実態はなく子を表示します
 * @constructor
 */
const WidgetTrigger = ({
  state,
  dispatch,
  embedded,
  desktop,
  nps = {},
  ...props
}) => {
  // /**
  //  * state {object} - {@link config}.reduce 戻り値
  //  * dispatch {function} - {@link config}.Context state 変更関数 - type 指定を行います
  //  */
  // const { state, dispatch } = useContext(survey.Context);
  const { config } = state;

  const stepRef = useRef(state.step);
  const watchedRef = useRef(false);

  // config.triggerIdName HTMLElement
  const trigger = useRef(document.getElementById(config.triggerIdName));
  // throttle 化された scroll event handler - didMount で実態生成
  const throttleWatchScroll = useRef(null);

  // // ---
  // scene step activate - 0 - start widget
  // trigger element: null or hit
  // @update - 20191205
  // state.step number を key に条件分岐させます
  const activateSequence = useCallback(() => {
    // console.log('WidgetTrigger.activateSequence', stepRef.current);
    if (stepRef.current < 0) {
      state.type = survey.events.UPDATE;
      state.step = 0;
      dispatch(state);
    }
  }, [stepRef, state, dispatch]);

  // release scroll watch
  const unwatchScroll = useCallback(() => {
    // console.log('WidgetTrigger.unwatchScroll', trigger.current);
    if (throttleWatchScroll.current) {
      watchedRef.current = false;
      window.removeEventListener('scroll', throttleWatchScroll.current);
    }
  }, [throttleWatchScroll, watchedRef]);

  // scroll event handler - logic from phase1
  const watchScroll = useCallback(() => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const { top } = trigger.current.getBoundingClientRect();
    const triggerTop = top + scrollTop;
    const viewHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      window.screen.height;
    const viewBottom = scrollTop + viewHeight;

    if (triggerTop < viewBottom) {
      // activate
      unwatchScroll();
      activateSequence();
    }
  }, [unwatchScroll, activateSequence]);

  // didMount
  const activateWithDidMount = useCallback(() => {
    // console.log('WidgetTrigger.activateWithDidMount', trigger.current);
    if (trigger.current) {
      throttleWatchScroll.current = throttle(watchScroll, 100);
      watchedRef.current = true;
      window.addEventListener('scroll', throttleWatchScroll.current, false);
    } else {
      activateSequence();
    }
  }, [watchScroll, activateSequence, trigger, watchedRef]);

  // willUnmount callback
  const cleanupWithUnmount = useCallback(() => {
    // console.log('WidgetTrigger.cleanupWithUnmount', trigger.current);
    if (trigger.current) {
      unwatchScroll();
    }
  }, [trigger, unwatchScroll]);

  // flag - one time execute を保証する
  const activateOnce = useRef(false);
  // didMount / willUnmount setting
  useEffect(() => {
    // console.log('WidgetTrigger.useEffect - mount', trigger.current);
    if (!activateOnce.current) {
      activateOnce.current = true;
      activateWithDidMount();
    }

    // ---
    // willUnmount
    return cleanupWithUnmount;
  }, [activateWithDidMount, cleanupWithUnmount]);

  // @since 20191211 - nps checked で unwatch するを追加
  useEffect(() => {
    if (nps.type === action.type.APPEAR || nps.type === action.type.CHANGE) {
      if (watchedRef.current) {
        unwatchScroll();
      }
      activateSequence();
    }
  }, [watchedRef, unwatchScroll, activateSequence, nps]);

  // console.log(
  //   'WidgetTrigger - state.step, stepRef.current, trigger.current, config.triggerIdName',
  //   state.step,
  //   stepRef.current,
  //   trigger.current,
  //   config.triggerIdName
  // );
  return <>{props.children}</>;
};

export default WidgetTrigger;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/widget/WidgetTrigger.js